// extracted by mini-css-extract-plugin
export default {"mutableTabBar":"MutableTabBar_mutableTabBar__grdh-"};